import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  constructor(private meta: Meta) { }

 

  ngOnInit(): void {
    // const subdomain = window.location.hostname.split('.')[0];
    // if (subdomain === 'qaappgames') {
    //   // Your code logic here for the 'games' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: 'https://qaappgames.statementgames.com' });
    //   this.meta.updateTag({ property: 'og:image', content: 'https://qaappgames.statementgames.com/assets/img/qaappgames-social.png' });
    // } else if (subdomain === 'qaappsportshosts') {
    //   // Your code logic here for the 'sportshosts' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: 'https://qaappsportshosts.statementgames.com' });
    //   this.meta.updateTag({ property: 'og:image', content: 'https://qaappsportshosts.statementgames.com/assets/img/qaappsportshosts-social.png' });
    // } else if (subdomain === 'idpguys') {
    //   // Your code logic here for the 'idpguys' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else if (subdomain === 'qaappintellectfaces') {
    //   // Your code logic here for the 'intellectfaces' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: 'https://qaappintellectfaces.statementgames.com' });
    //   this.meta.updateTag({ property: 'og:image', content: 'https://qaappintellectfaces.statementgames.com/assets/img/qaappintellectfaces-social.png' });
    // } else if (subdomain === 'thepeachbasket') {
    //   // Your code logic here for the 'thepeachbasket' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else if (subdomain === 'clever') {
    //   // Your code logic here for the 'clever' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else if (subdomain === 'flteams') {
    //   // Your code logic here for the 'flteams' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else if (subdomain === 'thelead') {
    //   // Your code logic here for the 'thelead' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else if (subdomain === 'apptivo') {
    //   // Your code logic here for the 'apptivo' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else if (subdomain === 'fivereasons') {
    //   // Your code logic here for the 'fivereasons' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else if (subdomain === 'heychuck') {
    //   // Your code logic here for the 'heychuck' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else if (subdomain === 'beyondwomenssports') {
    //   // Your code logic here for the 'beyondwomenssports' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else if (subdomain === 'franchisesports') {
    //   // Your code logic here for the 'franchisesports' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else if (subdomain === 'bellyupsports') {
    //   // Your code logic here for the 'bellyupsports' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else if (subdomain === 'sportswriters') {
    //   // Your code logic here for the 'sportswriters' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else if (subdomain === 'dynastydna') {
    //   // Your code logic here for the 'dynastydna' subdomain
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // } else {
    //   // Your code logic here for non-matching subdomains
    //   this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    //   this.meta.updateTag({ property: 'og:image', content: `` });
    // }
    this.updateMetaTags();
  }

  updateMetaTags() {
    const subdomain = window.location.hostname.split('.')[0];
    this.meta.updateTag({ property: 'og:url', content: `https://${subdomain}.statementgames.com` });
    // Update the og:image meta tag
    this.meta.updateTag({ property: 'og:image', content: `https://${subdomain}.statementgames.com/assets/img/${subdomain}-social.jpg` });

    // Update the twitter:image meta tag
    this.meta.updateTag({ name: 'twitter:image', content: `https://${subdomain}.statementgames.com/assets/img/${subdomain}-social.jpg` });
  }
  
 
}



